import { FadeLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Stack, Typography } from '@mui/material';
import Page from '../../components/Page';
import tracker from '../../api/tracker';
import BulletinForm from '../../sections/@dashboard/bulletins/BulletinForm';
import PrintButton from '../../components/print/PrintButton';
import BulletinPrintTemplate from '../../sections/@dashboard/bulletins/BulletinPrintTemplate';

// ---------------------------------------------------------------------

export default function EditBulletin() {
  const [loading, setLoading] = useState(true);
  const { hashid } = useParams();
  const [bulletin, setBulletin] = useState();
  const { t } = useTranslation();

  const fetchBulletinData = async () => {
    try {
      const response = await tracker.get(`bulletins/${hashid}`);
      setBulletin(response.data.data);
    } catch (e) {
      console.error('Failed to load bulletin', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBulletinData();
  }, [hashid]);

  return (
    <>
      <BulletinPrintTemplate bulletin={bulletin} />
      <Page title={t('bulletin_form')}>
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 4 }}>
            <Typography variant="h4" fontWeight={800} sx={{ color: '#032C65' }}>
              {t('edit_bulletin') || 'Editar Boletín'}
            </Typography>
            {!loading && bulletin && <PrintButton />}
          </Stack>
          <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <FadeLoader color="#032C65" cssOverride={{ margin: '0 auto' }} loading={loading} />
              </Box>
            ) : (
              <BulletinForm bulletin={bulletin} />
            )}
          </Box>
        </Container>
      </Page>
    </>
  );
}
